import get from 'lodash/get';

function parseBody(body) {
  // Yes, you are right, we are dealing with XML here.
  // VAST standard defines the template as XML files, nothing we can do unfortunately.
  // https://www.iab.com/wp-content/uploads/2015/06/VASTv3_0.pdf
  const parser = new DOMParser();
  const doc = parser.parseFromString(body, 'application/xml');

  return {
    impression: doc.getElementsByTagName('Impression')[0].textContent,
    click: doc.getElementsByTagName('ClickTracking')[0].textContent,
    start: doc.querySelector('Tracking[event="start"]').textContent,
    firstQuartile: doc.querySelector('Tracking[event="firstQuartile"]')
      .textContent,
    midpoint: doc.querySelector('Tracking[event="midpoint"]').textContent,
    thirdQuartile: doc.querySelector('Tracking[event="thirdQuartile"]')
      .textContent,
    complete: doc.querySelector('Tracking[event="complete"]').textContent,
    pause: doc.querySelector('Tracking[event="pause"]').textContent,
    resume: doc.querySelector('Tracking[event="resume"]').textContent,
    mute: doc.querySelector('Tracking[event="mute"]').textContent,
    unmute: doc.querySelector('Tracking[event="unmute"]').textContent,
    rewind: doc.querySelector('Tracking[event="rewind"]').textContent,
    fullscreen: doc.querySelector('Tracking[event="unmute"]').textContent,
  };
}

function createImageTag(src) {
  if (!src) return;

  let img = new Image();
  img.onload = () => {
    img.onload = null;
    img = null;
  };
  img.setAttribute('src', src);
}

function track(vastTrackers, eventName, videoUrl) {
  // Make sure we know what impressions belong to this file
  const src = get(vastTrackers, `['${videoUrl}']['${eventName}']`);
  createImageTag(src);
}

export const Vast = {
  parseBody,
  track,
};
